/**
 * @providesModule AuthorsList
 * 
 */

import * as React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { injectIntl, FormattedMessage } from 'react-intl'

import { Button, Dialog, Intent } from '@blueprintjs/core'

import { displayToast } from 'redux/actions'
import { isCompact } from 'shared/functions'

import SortableList, { createSortableInput } from 'utility/SortableList'



class AuthorsListForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = { ...props.byline }
  }

  handleChangeAuthors = authors => {
    this.setState({ authors })
  }

  handleChangeTranslators = (translators) => {
    this.setState({ translators })
  }

  handleChangeAcknowledgements = (
    e
  ) => {
    this.setState({ acknowledgements: e.currentTarget.value })
  }

  handleCancel = () => {
    this.props.onFinishEditing(null)
  }

  handleDone = () => {
    if (formStateClean(this.state)) {
      this.props.onFinishEditing(this.state)
    } else {
      this.props.displayToast({
        message: this.props.intl.formatMessage({
          id: 'cases.edit.missedSomething',
        }),
        intent: Intent.WARNING,
      })
    }
  }

  render () {
    const { editing, intl } = this.props
    const { authors, translators, acknowledgements } = this.state
    return (
      <Dialog
        isOpen={editing}
        icon="edit"
        className="bp6-dark"
        title={intl.formatMessage({ id: 'cases.edit.editingAuthors' })}
        style={{ width: 700 }}
        onClose={this.handleCancel}
      >
        <div className="bp6-dialog-body">
          <SectionTitle>
            <FormattedMessage id="activerecord.attributes.case.authors" />
          </SectionTitle>
          <SortableList
            dark
            items={authors}
            newItem=""
            render={AuthorInput}
            onChange={this.handleChangeAuthors}
          />

          <SectionTitle>
            <FormattedMessage id="activerecord.attributes.case.translators.other" />
          </SectionTitle>
          <SortableList
            dark
            items={translators}
            newItem=""
            render={TranslatorInput}
            onChange={this.handleChangeTranslators}
          />
          <SectionTitle>
            <FormattedMessage id="activerecord.attributes.case.acknowledgements" />
          </SectionTitle>
          <textarea
            className="bp6-input bp6-fill"
            value={acknowledgements}
            onChange={this.handleChangeAcknowledgements}
          />
        </div>
        <div className="bp6-dialog-footer">
          <div className="bp6-dialog-footer-actions">
            <Button text="Cancel" onClick={this.handleCancel} />
            <Button
              intent={Intent.SUCCESS}
              text={intl.formatMessage({ id: 'helpers.save' })}
              onClick={this.handleDone}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}

export default connect(
  undefined,
  { displayToast }
)(injectIntl(AuthorsListForm))

function formStateClean ({
  authors,
  translators,
}) {
  return isCompact(authors.map(a => a.name || '')) && isCompact(translators)
}

const BaseAuthorInput = ({ intl, item, onChangeItem }) => (
  <span style={{ display: 'flex' }}>
    <input
      className="bp6-input"
      type="text"
      placeholder={intl.formatMessage({ id: 'cases.edit.authorName' })}
      value={item.name}
      onChange={(e) => {
        onChangeItem({ ...item, name: e.target.value })
      }}
    />

    <input
      className="bp6-input"
      style={{ flexGrow: 1 }}
      type="text"
      placeholder={intl.formatMessage({ id: 'cases.edit.authorInstitution' })}
      value={item.institution}
      onChange={(e) => {
        onChangeItem({ ...item, institution: e.target.value })
      }}
    />
  </span>
)
const AuthorInput = injectIntl(BaseAuthorInput)

const TranslatorInput = createSortableInput({
  placeholderId: 'cases.edit.translatorName',
})

const SectionTitle = styled.h5`
  /* Keep these section headers as <h5>, but match prod's sizing: BP2 sized headings
     globally (h5 = 16px/600); BP6 leaves a bare <h5> at the browser default
     (13.28px/700). */
  font-size: 16px;
  font-weight: 600;

  &:not(:first-child) {
    margin-top: 2em;
  }
`
